export const CONTAINER_LAYOUTS_TYPES = new Set([
	'GridContainerLayout',
	'FlexContainerLayout',
	'OrganizerContainerLayout',
	'StackContainerLayout',
	'MeshContainerLayout',
])
